/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileArrowRight = createReactComponent("file-arrow-right", "IconFileArrowRight", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M9 15h6", key: "svg-2" }],
  ["path", { d: "M12.5 17.5l2.5 -2.5l-2.5 -2.5", key: "svg-3" }]
]);

export { IconFileArrowRight as default };
//# sourceMappingURL=IconFileArrowRight.js.map
